import styled from 'styled-components';
import { BodyRegularS, CaptionBoldL, HeadingExtraBoldM, LabelRegularM } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ISurveyContentsCont {
  theme: ITheme;
  loading: boolean;
}

export const SurveyContentsCont = styled.div<ISurveyContentsCont>`
  ${({ loading }: ISurveyContentsCont) => `
    ${loading ? 'display: none' : 'display: initial'};
  `}
`;

export const SurveyContentsBody = styled.div`
  display: flex;
  margin-top: 24px;
`;

interface ISurveyContentsHeader {
  theme: ITheme;
  isIntersecting?: boolean;
}

export const SurveyContentsHeader = styled.div<ISurveyContentsHeader>`
  display: flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  /* Only a bottom divider — the tabs above already provide the top separation */
  border-width: 0 0 1px;
  border-style: solid;
  ${({ theme }: ISurveyContentsHeader) => `
    margin: ${theme.layout.spacing.mikro} 56px ${theme.layout.spacing.mikro} 0;
    padding: ${theme.layout.spacing.centy} 0;
    color: ${theme.colors.neutral.primary[80]};
    border-color: ${theme.colors.neutral.primary[20]};
  `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  padding-right: 22px;
`;

export const BoldText = styled.span`
  font-weight: 700;
`;

export const QuestionsInfo = styled.span`
  margin: 0 64px;
`;

export const CreateMenuCont = styled.div`
  width: 320px;
`;

export const ContentBody = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;

  h1 {
    font-size: 20px;
    line-height: 24px;
    padding-bottom: 12px;
  }
`;

interface IBodyCont {
  theme: ITheme;
  isInViewPort?: boolean;
  /** Measured height (px) that makes the page fit the viewport exactly. */
  $fillHeight?: number;
}

export const BodyCont = styled.div<IBodyCont>`
  width: auto;
  box-sizing: border-box;
  min-width: 600px;
  max-width: 100%;
  overflow: auto;
  position: relative;
  ${({ theme, isInViewPort, $fillHeight }: IBodyCont) => `
  height: ${
  $fillHeight
    ? `${$fillHeight}px`
    : isInViewPort
      ? 'calc(100vh - 330px)'
      : 'calc(100vh - 250px)'
};
  padding: 0 ${theme.layout.spacing.centy} 0 0;
    ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${theme.colors.secondary[30]};
    border-radius: 4px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.secondary[70]};
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.secondary[100]};
  }
  `}
`;

export const BodyTitle = styled(CaptionBoldL)`
  display: flex;
  align-items: center;
  padding-right: 22px;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const StaticContainerScreen = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 0px 8px 8px 0px;
  position: relative;
  ${({ theme }: IThemeProvider) => `
    padding: 32px;
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[10]};
    margin: 0 0 ${theme.layout.spacing.centy} 0;
    background: ${theme.colors.neutral.primary[0]};
  `}
`;

export const HeaderCont = styled.div`
  position: relative;
  height: 200px;
`;

export const PrologEpilogTitle = styled(LabelRegularM)`
  ${({ theme }: IThemeProvider) => `
    margin:  ${theme.layout.spacing.deka} 0 0 0;
  `}
`;

export const PrologTitlePlaceholder = styled(BodyRegularS)`
  padding: 14px 12px 15px 12px;
  border-radius: 8px;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.nano} 0 0 0;
    border: 1px solid ${theme.colors.neutral.primary[10]};
  `}
`;

export const SpinnerCont = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;

  .ant-spin-dot {
    font-size: 60px;

    .ant-spin-dot-item {
      width: 23.83px;
      height: 23.83px;
    }
  }
`;

export const HeadTitle = styled(HeadingExtraBoldM)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.decy} 0;
  `}
`;

